// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "src_themes_zero-un_js_templates_Default_jsx") return "zero-un/assets/js/chunks/" + chunkId + ".ada5c702e1fded3ca551.js";
	if (chunkId === "src_themes_zero-un_js_templates_NotFound_jsx") return "zero-un/assets/js/chunks/" + chunkId + ".9d15722fbd24fc173eb6.js";
	// return url for filenames based on template
	return undefined;
};